import React from "react";

import { Grid, Modal, TextField, Button } from "@mui/material";
import s from "../../OrdenesPedido/Search/OrdersModal.module.css";
import CloseIcon from "@mui/icons-material/Close";

import { useTranslation } from "react-i18next";

const ModalProviders = ({
  open,
  setOpen,
  filters,
  setFilters,
  setSearching,
  setNewFilters,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid item xs={10} className={s.exit}>
            <div className={s.titleModal}>
              <p>{t("filter")}</p>
              <span>{t("filterConfig")}</span>
            </div>
            <CloseIcon
              onClick={() => setOpen(false)}
              className={s.exitIcon}
              sx={{ color: "primary.dark", fontSize: "1.6rem" }}
            />
          </Grid>

          <Grid container item xs={12} className={s.filters}>
            <Grid item xs={8}>
              <TextField
                label={t("name")}
                variant="outlined"
                value={filters.razonsocial}
                sx={{ width: "100%", mt: 3 }}
                helperText={t("paramsIgnore")}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    razonsocial: e.target.value,
                    cuit: 0,
                  }))
                }
              />
            </Grid>
            <Grid item xs={8} mb={3}>
              <TextField
                label={t("CUIT")}
                value={filters.cuit}
                variant="outlined"
                sx={{ width: "100%", mt: 3 }}
                helperText={t("paramsIgnore")}
                onChange={(e) =>
                  setFilters((prev) => ({
                    ...prev,
                    cuit: e.target.value,
                    razonsocial: "",
                  }))
                }
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={10}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: "20px",
              cursor: "not-allowed",
            }}
          >
            <Button
              sx={{ fontSize: "0.8rem" }}
              variant="contained"
              disabled={filters.razonsocial === "" && filters.cuit === 0}
              onClick={() => {
                setOpen(false);
                setSearching(true);
                setNewFilters(filters);
              }}
            >
              {t("apply")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalProviders;
